import wrapWithProvider from "./src/components/wrapWithProvider.jsx"
export const wrapRootElement = wrapWithProvider
